import {React, useState, useEffect} from 'react';
import Slider from "react-slick";

import SectionTitle from '../../components/SectionTitle'
import SingleTestimonial from '../../components/Testimonial/SingleTestimonial';

import testiImg from '../../assets/images/testimonial/testimonial.png';
import comaImg from '../../assets/images/testimonial/coma.png';


//import React from 'react';
//import HomeMain from './HomeMain';
import Header from '../../components/Header/index';
import Footer from '../../components/Footer';
//import urls from './../../constants/urls';
//import { useState } from 'react';
//const [APIROOTURL, setAPIROOTURL]=useState(urls.rootAPIURL);
//import footerLogo from 'https://www.bfatechnologies.tech/images/assets/images/logos/footer-logo.png';
import urls from '../../constants/urls.js';

const AllSchools = ( {sendDataToParent, sendPageToIndex} ) => {
    return (
        <>
            <Header
                parentMenu='home'
                topbarEnable='enable'
                sendDataToParent={sendDataToParent}
                sendPageToIndex={sendPageToIndex}

            />
            <AllSchoolsEXT />
            <Footer
                footerLogo='https://www.bfatechnologies.tech/images/assets/images/logos/footer-logo.png'
            />
        </>
    );
}

export default AllSchools;


function AllSchoolsEXT ()  {
    const [APIROOTURL, setAPIROOTURL]=useState(urls.rootAPIURL);
   
    const [schools, setSchools]=useState([])
   
    const testimonialSettings = {
        dots: false,
        arrows: true,
        infinite: true,
        centerMode: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 1,
                }
            },
            {

                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    arrows: false,
                }
            }
        ]
    };


    
      const loadSchools=(data)=>{
        let newList=[]
        newList.push({ id: 0, label: 'Select student', value: 'Select student', name: 'student'})
        {   
            data.map(function(dt){
              let x=0
              //if(x===0){ 
              //city_name
              newList.push(
                {
                    schoolId: dt.school_id, 
                    schoolName: dt.school_name, 
                    schoolTelephone1: dt.telephone_number_1 , 
                    schoolTelephone2: dt.telephone_number_2 , 
                    schoolCity: dt.city_name , 
                    schoolDistrict: dt.district_name , 
                })
              //console.log("dt.name=" + dt.name)
               //}
    
            })
        }
       
        //console.log("newList newList[0]['value'] =" + newList[0]['value'] + ", newList newList[1]['value'] =" + newList[1]['value'])
        
        setSchools(newList)
      }
      
          
      useEffect(()=>{
        //alert(schoolIdGlobal + "," + usersId)
      let APIURL= APIROOTURL + "SchoolsViewEXT" + ""
      let headerOptions={
          method: 'GET',
      }
      
      fetch(APIURL, headerOptions)
      .then( response => response.json())
      .then( json =>{
       console.log("json 639 hyj =" + json);
       //console.log("json 5123 =" + json[0]['name']);
       //console.log("json 123 =" + json[0].name);
       loadSchools(json)
      })
      .catch(error=> console.log("error=" + error))
      
      },[])
    
    

    return (
        <>
            <div className="react-clients react-clientso home-testimonial pt---90 pb---120">
                <div className="container">
                  
                    <SectionTitle Title="Our Schools" />
                   
                   {
                    schools.map( function(dt){
                      return(
                     
                    <div className="client-slider wow animate__fadeInUp" data-wow-duration="0.3s" key={dt.schoolId}>
                       
                        
                        {/***<Slider {...testimonialSettings}> ***/}
                            
                            <SingleTestimonial
                                itemClass="single-client"
                                itemImg='https://www.bfatechnologies.tech/images/assets/school_01.jpg'
                                Title={dt.schoolName}
                                Designation={dt.schoolCity +  '' +  dt.schoolDistrict}
                                Desc={'Contact us through our school mobile numbers ' +  dt.schoolTelephone1 + ',  ' +  dt.schoolTelephone2}
                                ratingCount='4.9'
                                reviewCount='14'
                                comaImg={comaImg}
                            />
                            {/*** *
                            <SingleTestimonial
                                itemClass="single-client"
                                itemImg={testiImg }
                                Title="Justin Case"
                                Designation="Student"
                                Desc="Nulla porttitor accumsan tincidunt. vamus magna justo, lacinia eget consectetur sed, convallis at tellus. Curabitur non nulla sit amet nisl tempus convallis quis ac lectus. Quisque velit nisi, pretium ut lacinia in."
                                ratingCount='4.9'
                                reviewCount='14'
                                comaImg={comaImg}
                            />
                           
                            <SingleTestimonial
                                itemClass="single-client"
                                itemImg={testiImg }
                                Title="Justin Case"
                                Designation="Student"
                                Desc="Nulla porttitor accumsan tincidunt. vamus magna justo, lacinia eget consectetur sed, convallis at tellus. Curabitur non nulla sit amet nisl tempus convallis quis ac lectus. Quisque velit nisi, pretium ut lacinia in."
                                ratingCount='4.9'
                                reviewCount='14'
                                comaImg={comaImg}
                            />
                           
                            <SingleTestimonial
                                itemClass="single-client"
                                itemImg={testiImg }
                                Title="Justin Case"
                                Designation="Student"
                                Desc="Nulla porttitor accumsan tincidunt. vamus magna justo, lacinia eget consectetur sed, convallis at tellus. Curabitur non nulla sit amet nisl tempus convallis quis ac lectus. Quisque velit nisi, pretium ut lacinia in."
                                ratingCount='4.9'
                                reviewCount='14'
                                comaImg={comaImg}
                            />
                           
                            <SingleTestimonial
                                itemClass="single-client"
                                itemImg={testiImg }
                                Title="Justin Case"
                                Designation="Student"
                                Desc="Nulla porttitor accumsan tincidunt. vamus magna justo, lacinia eget consectetur sed, convallis at tellus. Curabitur non nulla sit amet nisl tempus convallis quis ac lectus. Quisque velit nisi, pretium ut lacinia in."
                                ratingCount='4.9'
                                reviewCount='14'
                                comaImg={comaImg}
                            />
                            ***/}
                       {/*** * </Slider> ***/}
                        

                    </div>
                       
                    )  
                })
               }
                </div>
            </div>
        </>
    )
}

